import script from "./DashboardHome.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardHome.vue?vue&type=script&setup=true&lang=js"

import "./DashboardHome.vue?vue&type=style&index=0&id=a8a4441a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8a4441a"]])

export default __exports__